<template>
  <div>
    <div
      style="display: flex; justify-content: space-between; margin: 0 auto 10px"
    >
      <div style="font-size: 20px; color: #000; font-weight: 500">
        📚书库列表
      </div>
      <div></div>
    </div>
    <Card>
      <Form label-position="top" :model="searchForm">
        <Row :gutter="10">
          <Col :span="4">
            <FormItem label="频道">
              <Select clearable filterable v-model="searchForm.channel">
                <Option
                  v-for="(item, index) in dictionary.PLAY_CHANNEL"
                  :key="index"
                  :value="item.dictValue"
                  >{{ item.dictName }}</Option
                >
              </Select>
            </FormItem>
          </Col>
          <Col :span="4">
            <FormItem label="一级分类">
              <Select clearable filterable v-model="searchForm.primaryCategory">
                <Option
                  v-for="(item, index) in dictionary.PRIMARY_CATEGORY"
                  :key="index"
                  :value="item.dictValue"
                  >{{ item.dictName }}</Option
                >
              </Select>
            </FormItem>
          </Col>
          <Col :span="4">
            <FormItem label="二级分类">
              <Select
                clearable
                filterable
                v-model="searchForm.secondaryCategory"
              >
                <Option
                  v-for="(item, index) in dictionary.NOVEL_SECONDARY_CATEGORY"
                  :key="index"
                  :value="item.dictValue"
                  >{{ item.dictName }}
                </Option>
              </Select>
            </FormItem>
          </Col>
          <Col :span="6">
            <FormItem label="搜索">
              <Input
                v-model="searchForm.keyword"
                placeholder="搜索书籍ID、内部书名、展示名、作者..."
              />
            </FormItem>
          </Col>
          <Col :span="3">
            <FormItem>
              <template #label>
                <div style="visibility: hidden">1</div>
              </template>
              <Button icon="ios-search" type="primary" @click="handleGetData()"
                >搜索</Button
              >
            </FormItem>
          </Col>
        </Row>
      </Form>
    </Card>

    <div style="margin: 10px 0; display: flex; justify-content: space-between">
      <div class="options">
        <Button icon="md-cloud-upload" @click="novelImportVisible = true"
          >导入小说</Button
        >
        <Button
          @click="handleExport"
          :loading="exportLoading"
          icon="md-download"
          >导出当前列表</Button
        >
        <Button icon="ios-paper" @click="handleOpenImportModal"
          >批量导入修改</Button
        >
      </div>
    </div>

    <div
      v-if="showProgress || mission.details.length"
      style="
        margin: 10px 0;
        background: #dbeafe;
        border-radius: 12px;
        padding: 12px;
        color: #1e40af;
        font-size: 14px;
        display: flex;
        align-items: center;
      "
    >
      <span
        v-if="showProgress"
        class="material-symbols-outlined animate-spin text-base"
        style="font-size: 14px"
      >
        cached
      </span>
      <span style="margin-left: 10px; color: #1e40af"
        >任务状态:{{ showProgress ? '正在处理中...' : '处理完成' }}</span
      >
      <span
        v-if="!showProgress"
        style="
          text-decoration: underline;
          margin-left: 5px;
          font-weight: 600;
          cursor: pointer;
        "
        @click="handleShowResult"
        >查看结果</span
      >
    </div>

    <Table
      style="margin-top: 10px"
      :columns="columns"
      ref="tableRef"
      :data="tableData"
      :loading="loading"
    >
      <template #img="{ row }">
        <div>
          <img
            @click="$viewerApi({ images: [row.fileUrl] })"
            style="width: 100%"
            :src="row.fileUrl"
          />
        </div>
      </template>
      <template #action="{ row }">
        <div>
          <a
            style="color: #2d8cf0; margin-right: 10px"
            @click="handleOpenModal(row)"
            >详情</a
          >
          <a style="color: #2d8cf0" @click="handleOpenPush(row)">推送</a>
        </div>
      </template>
      <Pages
        :func="handleGetData"
        :page="page"
        slot="footer"
        :pArr="[50, 100]"
      />
    </Table>

    <Main :form="form" v-model="visible" :dictionary="dictionary" />
    <Modal v-model="pushVisible" :width="420" title="推送">
      <Form label-position="top">
        <FormItem label="选择合作方：">
          <Select v-model="pushForm.partnerCode" placeholder="请选择合作方">
            <Option
              v-for="item in partnerList"
              :disabled="!item.enabled"
              :key="item.partnerCode"
              :value="item.partnerCode"
              >{{ item.partnerName }}</Option
            >
          </Select>
        </FormItem>
        <div style="color: #999; line-height: 1.8">
          <div>当前书籍：{{ pushForm.novelName || '-' }}</div>
        </div>
      </Form>
      <template #footer>
        <Button @click="pushVisible = false">取消</Button>
        <Button type="primary" :loading="pushLoading" @click="handlePush"
          >推送</Button
        >
      </template>
    </Modal>
    <upload
      :visible="uploadVisible"
      @cancel="uploadVisible = false"
      @confirm="handleExcelImportSuccess"
    />
    <NovelImport
      :visible="novelImportVisible"
      @cancel="novelImportVisible = false"
      @confirm="handleNovelImportSuccess"
    />
  </div>
</template>

<script>
import {
  getNovelPage,
  getNovelDetail,
  exportNovelExcel,
  getPartnerList,
  pushNovelToPartner
} from '@/api/novel'
import { getDictionaryList } from '@/api/dictionary'
import Pages from '@/components/pages'
import upload from './upload.vue'
import Main from './main.vue'
import NovelImport from './import.vue'

const formatPushChannelNames = (pushChannelNames) => {
  if (typeof pushChannelNames === 'string' && pushChannelNames) {
    return pushChannelNames
  }
  if (!Array.isArray(pushChannelNames) || !pushChannelNames.length) {
    return '-'
  }
  return pushChannelNames.join('、')
}

export default {
  name: 'novelList',
  components: {
    Pages,
    Main,
    upload,
    NovelImport
  },
  data() {
    return {
      form: {},
      uploadVisible: false,
      novelImportVisible: false,
      exportLoading: false,
      detailLoading: false,
      loading: false,
      pushLoading: false,
      pushVisible: false,
      showProgress: false,
      visible: false,
      partnerList: [],
      pushForm: {
        partnerCode: '',
        novelId: '',
        novelName: ''
      },
      searchForm: {},
      mission: {
        details: []
      },
      tableData: [],
      columns: [
        {
          width: 100,
          title: '书籍ID',
          fixed: 'left',
          always: true,
          key: 'id'
        },
        {
          width: 150,
          title: '内部书名',
          tooltip: true,
          fixed: 'left',
          always: true,
          tooltipMaxWidth: 200,
          key: 'chineseName'
        },
        {
          title: '展示名',
          tooltip: true,
          width: 150,
          tooltipMaxWidth: 200,
          key: 'novelName'
        },
        {
          title: '推送渠道',
          tooltip: true,
          width: 120,
          tooltipMaxWidth: 200,
          key: 'pushChannelNamesText'
        },
        {
          title: '书封',
          width: 60,
          key: 'img',
          slot: 'img'
        },

        {
          title: '作者',
          tooltip: true,
          width: 100,
          tooltipMaxWidth: 200,
          key: 'novelAuthor'
        },
        {
          title: '频道',
          width: 60,
          key: 'channelName'
        },
        {
          title: '一级分类',
          width: 90,
          key: 'primaryCategoryName'
        },
        {
          title: '二级分类',
          width: 90,
          tooltip: true,
          tooltipMaxWidth: 200,
          key: 'secondaryCategoryName'
        },
        {
          title: '标签',
          width: 130,
          key: 'tags',
          render: (h, params) => {
            const tags = params.row.tags || []
            if (!tags.length) return <span></span>
            const colorLi = [
              '#075985',
              '#115e59',
              '#3730a3',
              '#6b21a8',
              '#9f1239'
            ]
            const backGoundColorLi = [
              '#e0f2fe',
              '#ccfbf1',
              '#e0e7ff',
              '#f3e8ff',
              '#ffe4e6'
            ]
            return (
              <Tooltip>
                <div
                  slot="content"
                  style="display:flex;flex-wrap:wrap;width:150px"
                >
                  {tags.map((item, index) => (
                    <div
                      style={{
                        fontSize: '12px',
                        color: colorLi[index % 5],
                        whiteSpace: 'nowrap',
                        backgroundColor: backGoundColorLi[index % 5],
                        borderRadius: '50px',
                        marginTop: '5px',
                        marginRight: '2px',
                        display: 'inline-block',
                        padding: '2px 10px'
                      }}
                    >
                      {item}
                    </div>
                  ))}
                </div>
                <div style="padding: 10px 0;overflow:hidden;display:flex;flex-wrap:wrap;height: 48px;">
                  <div>
                    {tags.map((item, index) => (
                      <div
                        style={{
                          fontSize: '12px',
                          color: colorLi[index % 5],
                          backgroundColor: backGoundColorLi[index % 5],
                          borderRadius: '50px',
                          marginTop: '5px',
                          marginBottom: '50px',
                          whiteSpace: 'nowrap',
                          textOverflow: 'ellipsis',
                          marginRight: '2px',
                          display: 'inline-block',
                          padding: '2px 10px'
                        }}
                      >
                        {item}
                      </div>
                    ))}
                  </div>
                </div>
              </Tooltip>
            )
          }
        },
        {
          title: '章节数',
          width: 80,
          key: 'novelTotal'
        },
        {
          title: '字数',
          width: 70,
          key: 'wordCount'
        },
        {
          title: '付费章节',
          width: 110,
          key: 'paidChapters',
          render: (h, params) => {
            return <div>Chapter {params.row.paidChapters}</div>
          }
        },
        {
          title: '连载状态',
          width: 120,
          key: 'novelStatusName',
          render: (h, params) => {
            const colorLi = {
              0: '#f59e0b',
              1: '#137fec'
            }
            const backgroundColorLi = {
              0: '#f59e0b33',
              1: '#137fec33'
            }
            return (
              <div
                style={{
                  display: 'inline-block',
                  padding: '3px 10px',
                  backgroundColor: backgroundColorLi[params.row.novelStatus],
                  borderRadius: '50px',
                  color: colorLi[params.row.novelStatus]
                }}
              >
                {params.row.novelStatusName}
              </div>
            )
          }
        },
        {
          title: '最近更新',
          width: 150,
          key: 'updateTime'
        },
        {
          title: '操作',
          width: 160,
          key: 'action',
          align: 'center',
          fixed: 'right',
          slot: 'action'
        }
      ],
      page: {
        current: 1,
        size: 20,
        total: 0
      },
      dictionary: {
        PRIMARY_CATEGORY: [],
        PLAY_CHANNEL: [],
        NOVEL_SECONDARY_CATEGORY: []
      }
    }
  },
  methods: {
    handleGetData(current) {
      this.loading = true
      if (current) this.page.current = current
      else this.page.current = 1

      getNovelPage({
        ...this.page,
        ...this.searchForm
      })
        .then((r) => {
          const data = r.data || {}
          this.tableData = (data.records || []).map((item) => ({
            ...item,
            pushChannelNamesText: formatPushChannelNames(item.pushChannelNames)
          }))
          this.page.total = data.total || 0
        })
        .finally(() => {
          this.loading = false
        })
    },
    handleOpenImportModal() {
      this.uploadVisible = true
    },
    handleExcelImportSuccess(result) {
      this.uploadVisible = false
      this.handleGetData(this.page.current)
      if (result && result.details) {
        this.mission = result
        this.showProgress = false
        localStorage.setItem('novel-import-mission', JSON.stringify(result))
      }
      this.$Message.success('导入完成')
    },
    handleNovelImportSuccess(result) {
      this.novelImportVisible = false
      this.handleGetData(this.page.current)
      this.$Message.success('导入完成')
      this.showNovelImportResult(result)
    },
    showNovelImportResult(result) {
      const data = result || {}
      const successFileNames = Array.isArray(data.successFileNames)
        ? data.successFileNames
        : []
      const importedNovelIds = Array.isArray(data.importedNovelIds)
        ? data.importedNovelIds
        : []
      const errorList = Array.isArray(data.errorList) ? data.errorList : []
      const columns = [
        {
          title: '文件名',
          key: 'fileName'
        },
        {
          title: '错误类型',
          key: 'errorType'
        },
        {
          title: '错误信息',
          key: 'errorMessage'
        }
      ]

      this.$Modal.info({
        title: '导入结果',
        width: 900,
        closable: true,
        render: () => {
          return (
            <div>
              <div style="margin-bottom: 16px;line-height: 2;">
                <div>总文件数：{data.totalFiles || 0}</div>
                <div>成功文件数：{data.successFiles || 0}</div>
                <div>失败文件数：{data.failedFiles || 0}</div>
              </div>
              {successFileNames.length ? (
                <div style="margin-bottom: 16px;">
                  <div style="font-weight: 600;margin-bottom: 8px;">
                    成功文件
                  </div>
                  <div style="word-break: break-all;">
                    {successFileNames.join('、')}
                  </div>
                </div>
              ) : null}
              {importedNovelIds.length ? (
                <div style="margin-bottom: 16px;">
                  <div style="font-weight: 600;margin-bottom: 8px;">
                    导入书籍ID
                  </div>
                  <div style="word-break: break-all;">
                    {importedNovelIds.join(', ')}
                  </div>
                </div>
              ) : null}
              {errorList.length ? (
                <Table height={320} columns={columns} data={errorList}></Table>
              ) : (
                <div style="color:#999;">无错误明细</div>
              )}
            </div>
          )
        }
      })
    },
    async handleExport() {
      this.exportLoading = true
      try {
        const res = await exportNovelExcel({ ...this.page, ...this.searchForm })
        const blob = new Blob([res.data], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        })
        const link = document.createElement('a')
        link.href = URL.createObjectURL(blob)
        link.download = '小说列表.xlsx'
        link.click()
        URL.revokeObjectURL(link.href)
      } catch (e) {
        console.log(e)

        this.$Message.error('导出失败')
      } finally {
        this.exportLoading = false
      }
    },
    async handleOpenModal(row) {
      if (this.detailLoading) return
      this.detailLoading = true
      try {
        const r = await getNovelDetail(row.id)
        this.form = {
          ...row,
          ...(r.data || {})
        }
        this.visible = true
      } catch (e) {
        this.$Message.error('获取详情失败')
      } finally {
        this.detailLoading = false
      }
    },
    handleOpenPush(row) {
      this.pushForm = {
        partnerCode: '',
        novelId: row.id,
        novelName: row.novelName || row.chineseName || ''
      }
      this.pushVisible = true
    },
    handlePush() {
      if (!this.pushForm.partnerCode) {
        return this.$Message.warning('请选择合作方')
      }
      this.pushLoading = true
      pushNovelToPartner({
        novelId: this.pushForm.novelId,
        partnerCode: this.pushForm.partnerCode
      })
        .then((r) => {
          this.$Message.success('推送成功')
          this.pushVisible = false
        })
        .finally(() => {
          this.pushLoading = false
        })
    },
    handleShowResult() {
      const columns = [
        {
          title: '书籍ID',
          key: 'novelId'
        },
        {
          title: '书名',
          key: 'bookName'
        },
        {
          title: '处理消息',
          key: 'message'
        },
        {
          title: 'Excel行号',
          key: 'rowNumber'
        },
        {
          title: '处理状态',
          key: 'status'
        }
      ]

      this.$Modal.info({
        title: '导入结果',
        width: 1200,
        closable: true,
        render: () => {
          return (
            <div>
              <div>
                <span style="margin-right: 20px">
                  总处理数量:{this.mission.total}
                </span>
                <span style="margin-right: 20px">
                  成功处理数量:{this.mission.success}
                </span>
                <span>失败处理数量:{this.mission.failed}</span>
              </div>
              <Table
                height={500}
                columns={columns}
                data={this.mission.details || []}
              ></Table>
            </div>
          )
        }
      })
    },
    handleGetDict() {
      for (const key in this.dictionary) {
        getDictionaryList({
          current: 1,
          size: 1000,
          dictTopic: key
        }).then((r) => {
          this.dictionary[key] = (r.data && r.data.records) || []
        })
      }
    },
    handleGetPartnerList() {
      getPartnerList().then((r) => {
        this.partnerList = r.data || []
      })
    }
  },
  mounted() {
    const missions = localStorage.getItem('novel-import-mission')
    if (missions) {
      this.mission = JSON.parse(missions)
    }

    this.handleGetDict()
    this.handleGetPartnerList()
    this.handleGetData()
  }
}
</script>

<style lang="less" scoped>
/deep/.ivu-form-item {
  margin-bottom: 10px;
}

.options {
  & > * {
    margin-right: 10px;
  }
}

.animate-spin {
  animation: spin 1s linear infinite;
}

@keyframes spin {
  100% {
    transform: rotate(360deg);
  }
}

/deep/.ivu-table-fixed {
  pointer-events: none;

  & > * {
    pointer-events: auto;
  }
}
</style>
